import { ExcludedDay, ExcludedDays } from '../types';
import { convertToApiTime, formatTimeForInput } from './time';

/**
 * Parses excluded_days from API response, normalizing times to HH:mm.
 */
export const parseExcludedDaysFromApi = (
  excluded?: ExcludedDays
): ExcludedDay[] => {
  if (!excluded?.days?.length) return [];

  return excluded.days.map((entry) => {
    if (!entry.day || !/^\d{4}-\d{2}-\d{2}$/.test(entry.day)) {
      console.warn(`[parseExcludedDaysFromApi] Invalid date format: "${entry.day}"`);
    }
    return {
      day: entry.day,
      start_time: entry.start_time ? formatTimeForInput(entry.start_time) : null,
      end_time: entry.end_time ? formatTimeForInput(entry.end_time) : null,
      message: entry.message || '',
    };
  });
};

/**
 * Converts form-state excluded days back to the API payload shape (ISO times).
 */
export const buildExcludedDaysPayload = (
  days: ExcludedDay[]
): ExcludedDays => {
  return {
    days: days.map((entry) => ({
      day: entry.day,
      start_time: entry.start_time ? convertToApiTime(entry.start_time) : null,
      end_time: entry.end_time ? convertToApiTime(entry.end_time) : null,
      message: entry.message || null,
    })),
  };
};
